<ng-template #dynamicFooter>
  <finxone-web-frontend-dynamic-widgets [widgetsInstance]="footerWidgetInstances">
  </finxone-web-frontend-dynamic-widgets>
</ng-template>
<finxone-web-frontend-accounts-context-dropdown
  [dropdownListing]="dropdownListing"
  [dropdownTemplate]="dropdownTemplate"
  [showFlag]="showFlag"
  (scrolled)="handleChildScroll()"
  (selectionChanged)="onAccountSelected($event)"
  [leftIcon]="leftIcon"
  [rightIcon]="rightIcon"
  [selectedAccount]="selectedAccount"
  [currentInputStyle]="currentInputStyle"
  [leftIconStyle]="leftIconStyle"
  [rightIconStyle]="rightIconStyle"
  [textContent]="textContent"
  [renderedContent]="renderedContent"
  [accountContextFormGroup]="accountContextForm"
  [formInputId]="formInputId"
  [noRecordsTemplate]="noRecordsTemplate"
  [footerTemplate]="footerWidgetInstances ? dynamicFooter : null"
  [footerFloatingThreshold]="widgetConfig?.['floatValue']"
  [isScrollable]="isScrollable"
  [isScrollPeekEnabled]="isScrollPeekEnabled"
  [visibleItemsCount]="visibleItemsCount"
  [dropdownMenuDirection]="dropdownMenuDirection"
  [labelType]="labelType"
></finxone-web-frontend-accounts-context-dropdown>
